import { useCallback, useEffect, useRef, useState } from 'react';
import { AdaptVisualizerEditor } from '@start-set/wakadoo-editor-core';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';

interface UseAdaptVisualizerEditorParams {
	initialStructure: IEditorStructure;
	options?: {
		isEnableMouseWheel?: boolean;
		cameraPadding?: {
			leftRight: number;
			topBottom: number;
		};
		imageFileSourcePrefix?: string;
	};
}
/**
 * Хук для работы с AdaptVisualizerEditor.
 * Создает, обновляет и управляет визуальным редактором структур.
 */
export const useAdaptVisualizerEditor = ({
	initialStructure,
	options = {}
}: UseAdaptVisualizerEditorParams) => {
	const editorContainerRef = useRef<HTMLDivElement>(null);
	const [editor, setEditor] = useState<AdaptVisualizerEditor | null>(null);

	const {
		isEnableMouseWheel = true,
		cameraPadding = { leftRight: 80, topBottom: 80 },
		imageFileSourcePrefix = '/api/file/user',
	} = options;

	/** Эффект для инициализации редактора */
	useEffect(() => {
		if (!editorContainerRef.current) return;

		if (editor) {
			editor.destruct();
			setEditor(null);
		}

		const newEditor = new AdaptVisualizerEditor({
			isEnableMouseWheel,
			editorContainer: editorContainerRef.current,
			isCanvasHeightAdaptive: false,
			cameraPadding,
			imageFileSourcePrefix
		});

		newEditor.setStructure(initialStructure)
			.then(() => {
				setEditor(newEditor);
			})
			.catch(e => console.error("Ошибка установки структуры:", e));

		return () => {
			newEditor.destruct();
		};
	}, [initialStructure]);

	return { editorContainerRef, editor };
};
